<template>
  <div>
    <header :class="bgColor !== 'none' ? 'bgwhile' : ''">
      <div class="header" v-if="showhead">
        <div class="h_left">
          <div class="logo">
            <img @click="toHome" src="@/assets/logo.png" v-if="$store.state.bgImg" alt="login">
            <img @click="toHome" src="@/assets/logo1.png" v-else alt="login">
          </div>
          <div class="menu_item" :class="[action === index ? 'active_menu' : '',bgColor !== 'none'?'color_black':'']"
               v-for="(item, index) in menuList"
               @click="setActive(index, item)" :key="index">{{ item.title }}
          </div>
        </div>
        <div class="h_right">
          <div class="user" :class="bgColor !== 'none'?'border_black':''">

            <span v-if="!getToken()" @click="showLogin" style="padding: 0 12px;">登录</span>
            <el-popover
              v-else
              placement="top"
              width="230"
              trigger="click">
              <span slot="reference"> <div class="fl"><i class="el-icon-s-custom"
                                                         style="font-size: 23px"></i>{{ user.shopname }}</div> </span>
              <div class="user">
                <div class="userinfo">
                  <div class="title">用户信息</div>
                  <div>{{ user.shopname }}</div>
                </div>
                <div class="mobile">
                  <div class="title">用户电话</div>
                  <div>{{ user.mobile }}</div>
                </div>
                <div class="logout" @click="logout">
                  <div>登出</div>
                </div>
              </div>
            </el-popover>
          </div>
        </div>
      </div>

      <el-dialog
        :visible.sync="$store.state.dialogLogin"
        width="25%"
        :before-close="handleClose">
        <div class="login">
          <div class="login_title">登录</div>
          <h3>贵州海外国际旅游有限公司组团业务管理平台账号登陆</h3>

          <div class="login_form">
            <el-input placeholder="用户名" type="text" v-model="username"></el-input>
            <el-input placeholder="真实姓名" type="text" v-model="real_name"></el-input>
            <el-input placeholder="请输入电话号码" type="text" maxlength="11" show-word-limit
                      v-model.number="mobile"></el-input>
            <el-input placeholder="请输入密码" v-model="password" show-password></el-input>
          </div>

        </div>
        <span slot="footer" class="dialog-footer">
    <el-button @click="$store.commit('showDialogLogin', false)">取 消</el-button>
    <el-button type="primary" @click="login">登 录</el-button>
  </span>
      </el-dialog>

    </header>
  </div>
</template>

<script>
import {getInfo, login} from "@/api/login";
import {getToken, removeToken, removeUser, setToken, setUser} from "@/utils/auth";
import {mapState, mapMutations} from 'vuex';
import isBase64 from 'is-base64';
import {Base64} from 'js-base64';


export default {
  name: "Chead",
  data() {
    return {
      showhead: true,
      action: 0,
      username: '',
      password: '',
      real_name: '',
      mobile: '',
      menuList: [
        {
          title: '预订酒店',
          to: '/index'
        },
        {
          title: '预订车票',
          to: '/ticket'
        },
        {
          title: '我的订单',
          to: '/order'
        }
      ]
    }
  },
  computed: {
    ...mapState(['user', 'bgColor'])
  },
  created() {
    if (this.$router.history.current.query.v) {
      if(getToken) {
        removeToken();
      }

      this.showhead = false;
      let obj = JSON.parse(this.decode(this.$router.history.current.query.v));

      this.real_name = decodeURIComponent(obj.name);
      this.password = decodeURIComponent(obj.pwd);
      this.username = decodeURIComponent(obj.user);
      this.mobile = decodeURIComponent(obj.phone);
      let page = decodeURIComponent(obj.page);

      if (page == 'jd') {
        this.$router.push({
          path: '/index'
        })
      }
      if (page == 'hc') {
        this.$router.push({
          path: '/ticket'
        })
      }
      if (page == 'dd') {
        this.$router.push({
          path: '/order'
        })
      }

      this.logins();
    }
  },
  watch: {
    $route: {
      immediate: true,
      deep: true,
      handler: function (val, oldVal) {
        this.menuList.forEach((item, index) => {
          if (item.to == val.path) {
            this.action = index;
          }
        })
      }
    },
  },
  methods: {
    ...mapMutations(['setUserInfo']),
    getToken,
    setActive(index, item) {
      if (this.action !== index) {
        this.action = index;
        this.$router.push({
          path: item.to
        })
      }
    },
    toHome() {
      if (this.$route.name !== 'Index') {
        this.$router.push({
          name: 'Index',
        })
      }
    },
    handleClose(done) {
      done();
    },
    encode(str) {
      // 首先，我们使用 encodeURIComponent 来获得百分比编码的UTF-8，然后我们将百分比编码转换为原始字节，最后存储到btoa里面
      return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
        function toSolidBytes(match, p1) {
          return String.fromCharCode(Number('0x' + p1));
        }));
    },
    decode(str) {
      // 过程：从字节流到百分比编码，再到原始字符串
      return decodeURIComponent(atob(str).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
    },

    logout() {
      this.$store.commit('logout');
    }
    ,
    showLogin() {
      this.$store.commit('showDialogLogin', !this.$store.state.dialogLogin);
    },
    async logins() {
      this.$loads.show();
      try {
        let {data, code, msg} = await login(this.username.trim(), this.password, this.mobile, this.real_name);
        if (code == 0) {
          console.log(1)
          this.$loads.hidden();
          setToken(data.token);
          await this.getUserInfo();
          this.$message({
            message: msg,
            type: 'success'
          });
        } else {
          this.$loads.hidden();
          this.$message({
            message: msg,
            type: 'warning'
          });
        }
        this.$store.commit('showDialogLogin', false);
      } catch (e) {
        this.$loads.hidden();
      }
    },
    async login() {
      this.$loads.show();
      try {
        let {data, code, msg} = await login(this.username.trim(), this.password, this.mobile, this.real_name);
        if (code == 0) {
          this.$loads.hidden();
          setToken(data.token);
          await this.getUserInfo();
          this.$message({
            message: msg,
            type: 'success'
          });
          this.$router.go(0);
        } else {
          this.$loads.hidden();
          this.$message({
            message: msg,
            type: 'warning'
          });
        }
        this.$store.commit('showDialogLogin', false);
      } catch (e) {
        this.$loads.hidden();
      }
    }
    ,
    async getUserInfo() {
      this.$loads.show();
      try {
        let {data, code, msg} = await getInfo();
        if (code == 0) {
          console.log(2)
          this.$loads.hidden();


          setUser(JSON.stringify(data));
          this.setUserInfo(data);

        } else {
          this.$loads.hidden();
          this.$message({
            message: msg,
            type: 'warning'
          });
        }
      } catch (e) {
        this.$loads.hidden();
      }
    }
  }
}
</script>

<style lang="scss">
.el-popover {
  margin-top: 20px !important;
}

.el-autocomplete-suggestion {
  margin-top: 18px !important;
}

.el-picker-panel {
  margin-top: 18px !important;
}

</style>

<style lang="scss" scoped>
.bgwhile {
  background-color: #fff;
}

.color_black {
  color: black;
}

.border_black {
  border: 1px solid #000000 !important;
  color: black !important;
}

.user {
  > div {
    border-bottom: 1px solid #cccccc;
    padding: 15px;
  }

  .logout {
    display: flex;
    justify-content: center;

    > div {
      line-height: 45px;
      width: 80%;
      height: 45px;
      background-color: #e4e4e4;
      text-align: center;
      border-radius: 27px;
    }
  }
}

.fl {
  display: flex;
  align-items: center;
  gap: 10px;
}

.title {
  color: #676f86;
  font-size: 14px;
  margin-bottom: 5px;
}

.active_menu {
  color: #11cbf7 !important
}

.header {
  width: 1200px;
  height: 74px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  color: #ffffff;

  .h_left {
    display: flex;
    align-items: center;
    padding-right: 16px;

    .logo {
      > img {
        width: 116px;
        margin-right: 18px;
      }
    }

    .menu_item {
      margin: -1px 20px 0;
      font-size: 14px;
      cursor: pointer;
    }

    .menu_item:hover {
      color: #63BBD0;
    }
  }

  .h_right {
    display: flex;
    align-items: center;

    .user {
      display: flex;
      gap: 13px;
      align-items: center;
      justify-content: center;
      padding: 10px;
      border: 1px solid #ffffff;
      cursor: pointer;
      border-radius: 30px;
    }

    .user_list {
      position: sticky;
      top: 0;
      background-color: red;
    }
  }
}

.login {
  .login_title {
    text-align: center;
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    padding-bottom: 8px;
    border-bottom: 1px solid #e8e8e8;
    margin-bottom: 13px;
  }

  .login_form {
    width: 70%;
    padding: 15px 10px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 10px;
  }
}
</style>
